import React from "react";
import EntryWrap from "../../components/entryComponents/EntryWrap";
import SignInContent from "../../components/entryComponents/SignIn";

const SignIn = () => (
  <EntryWrap>
    <SignInContent />
  </EntryWrap>
);
export default SignIn;
